import api from '../api/axios';

export const searchDashboardSourceProfiles = ({ q } = {}) => {
  const params = {};
  if (q) params.q = q;
  return api.get('/api/source-profiles/search', { params }).then((r) => r.data);
};

export const getTeamLeadSourceProfiles = ({ from, to } = {}) => {
  const params = {};
  if (from) params.from = from;
  if (to) params.to = to;
  return api.get('/api/teamlead/source-profiles', { params }).then((r) => r.data);
};
